import { AHSeparator, ListItem, Circle, Dialog } from "arkh";
import { onPressInHaptic } from "../../onPressInHaptic";
import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { ScrollView } from "react-native";

type Tag = { id: string; color: string; title: string };

export function TodoTagsDialog(props: {
  selectedTagIds: string[];
  setSelectedTagIds: (tags: string[]) => void;
  visible: boolean;
  onClose: () => void;
  categoryTags: readonly Tag[];
}) {
  const renderItem = useCallback(
    (tag: Tag, index: number) => {
      const selected = props.selectedTagIds.includes(tag.id);
      return (
        <React.Fragment key={tag.id}>
          {index > 0 ? <AHSeparator /> : null}
          <ListItem
            left={
              <Circle size="badge" style={{ backgroundColor: tag.color }} />
            }
            right={<ListItem.SelectIndicator selected={selected} />}
            onPress={() => {
              onPressInHaptic();
              if (selected) {
                props.setSelectedTagIds(
                  props.selectedTagIds.filter((t) => t !== tag.id)
                );
              } else {
                props.setSelectedTagIds([...props.selectedTagIds, tag.id]);
              }
            }}
          >
            <ListItem.Title
              color={selected ? "text-primary" : "text-secondary"}
            >
              {tag.title}
            </ListItem.Title>
          </ListItem>
        </React.Fragment>
      );
    },
    [props]
  );

  return (
    <Dialog
      visible={props.visible}
      onClose={props.onClose}
      minHeight={400}
      title={
        <FormattedMessage description="Todo Tags Title" defaultMessage="Tags" />
      }
    >
      <ScrollView style={{ flex: 1 }}>
        {props.categoryTags.map(renderItem)}
      </ScrollView>
    </Dialog>
  );
}
